// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__T-vcz","icon":"EnquiryForm_icon__1NN32","heading":"EnquiryForm_heading__2MgAd","field":"EnquiryForm_field__1nsXb","error":"EnquiryForm_error__135qu"};